<template>
  <div>
    <v-text-field
      :loading="loading"
      solo
      :placeholder="$t('tracks.search')"
      style="margin:10px 10px 0 10px;"
      v-model="query"
    ></v-text-field>
    <v-layout wrap>
      <v-row style="margin: 0; padding: 0 10px;">
        <v-col cols="12" sm="6" md="3">
          <v-select rounded v-model="filter_track_type" :items="track_types" hide-details>
            <template v-slot:item="{item}">
              <i class="fad" :class="item.icon" style="margin-right:5px;"></i>
              <span>{{ $t(item.name) }}</span>
            </template>
            <template v-slot:selection="{item}">
              <i class="fad" :class="item.icon" style="margin-right:5px;"></i>
              <span>{{ $t(item.name) }}</span>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-menu
            ref="menu"
            v-model="menu_date"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="filter_date_display"
                @click:clear="filter_date = []"
                :label="$t('tracks.date')"
                prepend-inner-icon="fad fa-calendar-alt"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                rounded
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filter_date"
              :first-day-of-week="1"
              range
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-text-field
              v-model="filter_min_distance"
              type="number"
              :label="$t('tracks.min_distance')"
              append-icon="fad fa-ruler-horizontal"
              clearable
              rounded
              hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
              v-model="filter_max_distance"
              type="number"
              :label="$t('tracks.max_distance')"
              append-icon="fad fa-ruler-horizontal"
              clearable
              rounded
              hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-layout>
    <v-layout v-if="filter_active" style="margin:0;" wrap row>
      <v-flex sm6 xs12 md4 lg3 v-for="track in results" :key="track.id">
        <TrackCard
          :id="track.id"
          :name="track.data.name"
          :type="track.data.type"
          :image_path="track.data.thumb_path"
          :distance="track.data.calc_distance"
          :start_time="parseInt(track.data.start_time)"
          :track_type="parseInt(track.data.track_type)"
          :data="track.data.route"
        ></TrackCard>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { storage } from "../../schmucklicloud";
import TrackCard from "./TrackCard";

import track_types from "../../assets/data/types";

export default {
  data() {
    return {
      query: "",

      track_types: track_types.types,
      filter_track_type: 0,
      filter_date: [],
      filter_min_distance: null,
      filter_max_distance: null,
      menu_date: false,

      filter_active: false,

      results: [],
      loading: false
    };
  },
  computed: {
    filter_date_display() {
      if (!this.filter_date || this.filter_date.length === 0) return '';
      let sortedDates = [...this.filter_date].sort();
      return sortedDates.join(' ~ ');
    }
  },
  mounted() {
    //Adds the all parameter
    if (this.track_types[0].value !== 0) {
      this.track_types.unshift({ name: "All", icon: "fa-list", value: 0 });
    }

    const q = this.$route.query;
    let hasQuery = false;
    if (q.search) { this.query = q.search; hasQuery = true; }
    if (q.type) { this.filter_track_type = parseInt(q.type); hasQuery = true; }
    if (q.date) { this.filter_date = q.date.split(','); hasQuery = true; }
    if (q.min_dist) { this.filter_min_distance = q.min_dist; hasQuery = true; }
    if (q.max_dist) { this.filter_max_distance = q.max_dist; hasQuery = true; }

    if (hasQuery) {
        this.search(this.query);
    } else {
        this.search('');
    }
  },
  methods: {
    async search(query) {
      this.loading = true;

      var filters;
      if (this.filter_track_type === 0) {
        filters = [
          {
            column: "name",
            operator: "contains_i",
            value: query
          }
        ];
      } else {
        filters = [
          {
            column: "name",
            operator: "contains_i",
            value: query
          },
          {
            column: "track_type",
            operator: "==",
            value: this.filter_track_type
          }
        ]
      }

      var response = await storage.get(
        "tracks",
        filters,
        [
          {
            column: "start_time",
            order: "desc"
          }
        ],
        undefined,
        ((this.filter_date && this.filter_date.length > 0) || this.filter_min_distance || this.filter_max_distance) ? 500 : 10,
        ["route"]
      );
      if (response.isOK && response.data) {
        let res = response.data;

        if (this.filter_date && this.filter_date.length > 0) {
            let sortedDates = [...this.filter_date].sort();
            let startTarget = new Date(sortedDates[0]);
            let endTarget = sortedDates.length > 1 ? new Date(sortedDates[1]) : new Date(sortedDates[0]);
            startTarget.setHours(0,0,0,0);
            endTarget.setHours(23,59,59,999);

            res = res.filter(track => {
              if (track.data.start_time) {
                let trackDate = new Date(parseInt(track.data.start_time));
                return trackDate >= startTarget && trackDate <= endTarget;
              }
              return false;
            });
        }
        
        if (this.filter_min_distance) {
            res = res.filter(track => track.data.calc_distance >= parseFloat(this.filter_min_distance));
        }

        if (this.filter_max_distance) {
            res = res.filter(track => track.data.calc_distance <= parseFloat(this.filter_max_distance));
        }

        this.results = res;
      } else {
        this.results = [];
      }

      this.filter_active = !(this.query === "" && this.filter_track_type === 0 && (!this.filter_date || this.filter_date.length === 0) && !this.filter_min_distance && !this.filter_max_distance);
      this.$emit("resultschanged", this.filter_active);

      this.loading = false;
    },
    updateUrl() {
      const query = { ...this.$route.query };
      if (this.query) query.search = this.query; else delete query.search;
      if (this.filter_track_type !== 0) query.type = this.filter_track_type.toString(); else delete query.type;
      
      if (this.filter_date && this.filter_date.length > 0) {
        query.date = [...this.filter_date].sort().join(',');
      } else {
        delete query.date;
      }

      if (this.filter_min_distance) query.min_dist = this.filter_min_distance.toString(); else delete query.min_dist;
      if (this.filter_max_distance) query.max_dist = this.filter_max_distance.toString(); else delete query.max_dist;

      this.$router.replace({ query }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    }
  },
  watch: {
    query(q) {
      this.updateUrl();
      this.search(q);
    },
    filter_track_type() {
      this.updateUrl();
      this.search(this.query);
    },
    filter_date() {
      this.updateUrl();
      this.search(this.query);
    },
    filter_min_distance() {
      this.updateUrl();
      this.search(this.query);
    },
    filter_max_distance() {
      this.updateUrl();
      this.search(this.query);
    }
  },
  components: {
    TrackCard
  }
};
</script>

<style>
</style>